import React, {useEffect, useState} from "react"
import {useClearRefinements, useInstantSearch} from "react-instantsearch"
import {useTranslation} from "react-i18next"

type Props = {
    excludedAttributes?: string[];
};
const ClearFilters = ({excludedAttributes = []}: Props) => {
  const {canRefine, refine} = useClearRefinements({
    excludedAttributes: ['query'],
  })
  const {results} = useInstantSearch()
  const [query, setQuery] = useState(results.query)
  useEffect(() => {

    if (results.query !== query) {
      if (canRefine) {
        refine()
      }
      setQuery(results.query)
    }


  }, [results])
  const {t} = useTranslation()
  return (<>
    {canRefine && <div
      className="bb-filter-control-selected clear-all-filters "
      title="Eliminar filtros aplicados"
      onClick={refine}>
      <div className="bb-filter-control-unset icon bbicon-times-circle">
        {t("Remove applied filters")}
      </div>
    </div>}
  </>)
}
export default ClearFilters
